import * as z from 'zod';

export const ListInvoicesForMultipleOrdersRequest = z.object({
  orderIds: z.array(z.string()).min(0).max(100),
});
export const ListInvoicesForMultipleOrdersResponse = z.object({
  invoicesForOrder: z
    .array(
      z.object({
        orderId: z.string().describe('Order ID.').optional(),
        invoicesInfo: z
          .array(
            z.object({
              _id: z.string().describe('Invoice ID.').optional(),
              appId: z
                .string()
                .describe('ID of the app that set the invoice.')
                .optional(),
            })
          )
          .max(300)
          .optional(),
      })
    )
    .optional(),
});
